/* eslint-disable react/no-children-prop */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@mui/material';
import useAuth from 'context/useAuth';
import useLocalization from 'hooks/useLocalization';

import { AppRoutes } from 'routes';

const LogoButton = () => {
    const { formatMessage, locale } = useIntl();
    const { localizedPush } = useLocalization();
    const { user, userMFASession } = useAuth();
    const logo = `/images/fairstone_logo_reversed_${locale}.svg`;

    const handleLogoClick = () => {
        if (userMFASession) {
            window.location.href = `/${locale}` + formatMessage({ id: AppRoutes.loginPage });
        }
        return localizedPush(user ? AppRoutes.accounts : AppRoutes.loginPage);
    };

    return (
        <Button
            aria-label={`return to ${user ? 'account page' : 'login page'}`}
            className="logo-container"
            disableRipple={true}
            id="page-header-Button-logo"
            onClick={handleLogoClick}
        >
            <FormattedMessage
                children={(msg) => <img alt={msg} className="header-logo" src={logo} />}
                id="header.logo.alt"
            />
        </Button>
    );
};

export default LogoButton;
